import { validationMessages } from "../common/validationMessages";
import * as Yup from "yup";
export interface AddEditAddress {
    line1: string | undefined;
    line2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    country: string | undefined;
    timezone?: string;
    locationType?: string;
    limitedAccessSubtype?: string;
    areaType?: string;
    facilityType?: string;
    gateCode?: string;
    insideDelivery?: boolean;
    hasDock?: boolean;
    limitedAccess?: boolean;
    gateCodeRequired?: boolean;
    liftGateRequired?: boolean;
    drivingInstructions?: string;
}
export interface AddressmanagerLoadingStatusSummary {
    totalLocations: number;
    limitedAccess: number;
    liftgateNeeded: number;
    residential: number;
    fullyVerifiedAddress: number;
}

export interface AddressmanagerTerminalList {
    region: any;
    contact: any;
    address: any;
    result: boolean;
}

export interface AddressmanagerLoadingStatusResponse {
    result: boolean;
    summary: AddressmanagerLoadingStatusSummary;
    error?: string | null | undefined
}

export interface AddressesListModel {
    id: string,
    line1: string,
    line2: string,
    city: string,
    state: string,
    zip: string,
    country: string,
    latitude: string,
    longitude: string,
    formattedAddressId?: string,
    updatedBy?: string,
    dateUpdated?: string
}

export interface AddressNote {
    note: string;
    noteType?: string;
    addressId?: string;
    dateCreated?: string;
    dateUpdated?: string;
    id?: string;
    userCreated?: string;
    userUpdated?: string;
    createdBy?: string;
    updatedBy?: string;
}

export interface AddressDetailsModel {
    id?: string;
    line1: string;
    line2: string;
    zip: string;
    city: string;
    state: string;
    country: string;
    formattedAddressId?: string;
    locationType?: string;
    limitedAccessSubtype?: string;
    areaType?: string;
    facilityType?: string;
    gateCode?: string;
    timezone?: string;
    latitude?: string;
    longitude?: string;
    updatedBy?: string;
    dateUpdated?: string;

    insideDelivery?: boolean;
    hasDock?: boolean;
    limitedAccess?: boolean;
    gateCodeRequired?: boolean;
    liftGateRequired?: boolean;

    unloadingServiceTime?: string;
    averageDetentionTime?: string;
    drivingInstructions?: string;
}

export interface AddressNotes {
    id: string,
    note: string,
    noteType: string,
    userCreated: string,
    dateCreated: string,
    userUpdated: string,
    dateUpdated: string,
}
export interface AddressByIdResponse {
    id: string,
    line1: string,
    line2: string,
    zip: string,
    city: string,
    state: string,
    country: string,
    latitude: number | null,
    longitude: number | null,
    locationType: string,
    limitedAccessSubtype: string,
    areaType: string,
    facilityType: string,
    gateCode: string,
    insideDelivery: boolean | undefined,
    hasDock: boolean | undefined,
    limitedAccess: boolean | undefined,
    gateCodeRequired: boolean | undefined,
    liftGateRequired: boolean | undefined,
    unloadingServiceTime: string,
    averageDetentionTime: string,
    drivingInstructions: string,
}

export interface AddressChangeLog {
    modifiedAt: string;
    modifiedBy: string;
    changeDescription: string;
}

export interface NearestAddress {
    id: string;
    line1: string;
    city: string;
    state: string;
    zip: string;
    distanceMiles: number;
}

export interface TerminalType {
    id: string;
    type: string;
    description: string;
}

export interface Address {
    id: string;
    physicalAddress: string;
    city: string;
    stateProvince: string;
    zipPostalCode: string;
    country: string;
    isMailingAddressSame: boolean;
    mailingAddress?: string | null;
    mailingCity?: string | null;
    mailingStateProvince?: string | null;
    mailingZipPostalCode?: string | null;
    mailingCountry?: string | null;
    latitude: number;
    longitude: number;
}

export interface Contact {
    id: string;
    phoneNumber: string;
    terminalEmail: string;
    managerName: string;
    managerEmail: string;
    managerPhone: string;
    agentName?: string | null;
    agentEmail?: string | null;
    agentPhone?: string | null;
    agentAddress?: string | null;
    agCity?: string | null;
    agState?: string | null;
}

export interface Region {
    id: string;
    regionName: string;
    vpName: string;
    vpPhone: string;
    vpEmail: string;
    directorName: string;
    directorPhone: string;
    directorEmail: string;
}

export interface TerminalOpenHours {
    id: string;
    terminalNumber: number;
    fromTime: string;
    toTime: string;
    openDays: string;
    openHours: string;
    type: string;
}

export interface FacilityTypes {
    consolidationFacility: boolean;
    cutFacility: boolean;
    distributionFacility: boolean;
    outboundFacility: boolean;
    warehouse: boolean;
}

export interface Terminal {
    terminalName: string;
    terminalNumber: number;
    airportCode: string;
    status: string;
    division: string;
    warehouse: boolean;
    timezone: string;
    dateUpdated: string | null;
    updatedBy: string | null;
    terminalType: TerminalType;
    address: Address;
    contact: Contact;
    region: Region;
    terminalOpenHoursList: TerminalOpenHours[];
    facilityTypes: FacilityTypes;
    distanceMiles: number;
}

export interface NearestTerminal extends Terminal { }
export interface ServicingTerminal extends Terminal { }
export interface AssociatedAccount {
    dateUpdated: string;
    id: string;
    name: string;
    userUpdated: string;
    receivingHours: {
        accountNumber: number;
        dailyHoursMap: {
            WEDNESDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
            MONDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
            TUESDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
            FRIDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
            SUNDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
            THURSDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
            SATURDAY: {
                fromTime: string | null;
                toTime: string | null;
                isOpen: boolean;
            };
        };
        userUpdated: string | null;
        dateUpdated: string | null;
    };
}
export interface ProximityResponse {
    id: string;
    formattedAddressId: string;
    line1: string;
    line2: string | null;
    city: string;
    state: string;
    zip: string;
    country: string;
    timezone: string | null;
    latitude: number;
    longitude: number;
    dateUpdated: string;
    updatedBy: string;
    accountId: string | null;
    zipCodeMatches: {
        id: string;
        line1: string;
        line2: string | null;
        city: string;
        state: string;
        zip: string;
        country: string;
        timezone: string | null;
        latitude: number;
        longitude: number;
        nearestTerminal: string | null;
        nearestTerminalMiles: number | null;
        formattedAddressId: string;
        dateUpdated: string;
    }[];
    cityMatches: {
        id: string;
        line1: string;
        line2: string | null;
        city: string;
        state: string;
        zip: string;
        country: string;
        timezone: string | null;
        latitude: number;
        longitude: number;
        nearestTerminal: string | null;
        nearestTerminalMiles: number | null;
        formattedAddressId: string;
        dateUpdated: string;
    }[];
    nearestAddresses: NearestAddress[];
    nearestTerminal: NearestTerminal;
    servicingTerminal: ServicingTerminal;
}

export const validationSchemaForAddress = () => Yup.object({
    line1: Yup.string().matches(/\S+/, validationMessages.notValid).max(256, "The value must be no more than 256 characters").required(validationMessages.required),
    line2: Yup.string().optional(),
    city: Yup.string().required(validationMessages.required).max(64, "The value must be no more than 64 characters"),
    state: Yup.string().required(validationMessages.required),
    zip: Yup.string().matches(/^\d*$/, validationMessages.notValid).min(5, "The value must be no less than 5 digits").max(5, "The value must be no more than 5 digits").required(validationMessages.required),
    country: Yup.string().required(validationMessages.required),
    timezone: Yup.string().required(validationMessages.required).nullable(),
    locationType: Yup.string().required(validationMessages.required).nullable(),
    limitedAccessSubtype: Yup.string().when("locationType", {
        is: (val: string) => val === "Limited Access",
        then: Yup.string().required(validationMessages.required),
        otherwise: Yup.string().nullable(),
    }),
    areaType: Yup.string().required(validationMessages.required).nullable(),
    facilityType: Yup.string().optional(),
    gateCode: Yup.string().optional(),
    insideDelivery: Yup.boolean().optional(),
    hasDock: Yup.boolean().optional(),
    limitedAccess: Yup.boolean().optional(),
    gateCodeRequired: Yup.boolean().optional(),
    liftGateRequired: Yup.boolean().optional(),
    drivingInstructions: Yup.string().optional(),
});

export const noteValidationEditSchema = () => Yup.object({
    note: Yup.string().required(validationMessages.required),
});

export const noteValidationAddSchema = () => Yup.object({
    type: Yup.string().required(validationMessages.required),
    notes: Yup.string().required(validationMessages.required),
});

export const locationTypeOptions = [
    { label: "Commercial", value: "Commercial" },
    { label: "Residential", value: "Residential" },
    { label: "Mixed Use", value: "Mixed Use" },
    { label: "Limited Access", value: "Limited Access" },
];

export const subLocationTypeOptions = [
    { label: "Airport", value: "Airport" },
    { label: "Amusement Park", value: "Amusement Park" },
    { label: "Campground / RV Park", value: "Campground / RV Park" },
    { label: "Casino", value: "Casino" },
    { label: "Church", value: "Church" },
    { label: "Construction Site", value: "Construction Site" },
    { label: "Convention Center", value: "Convention Center" },
    { label: "Day Care / Preschool", value: "Day Care / Preschool" },
    { label: "Farm / Estate", value: "Farm / Estate" },
    { label: "Funeral Home", value: "Funeral Home" },
    { label: "Golf Course / Country Club", value: "Golf Course / Country Club" },
    { label: "Government", value: "Government" },
    { label: "Hospital", value: "Hospital" },
    { label: "Hotel", value: "Hotel" },
    { label: "Marina", value: "Marina" },
    { label: "Military base", value: "Military base" },
    { label: "Mine / Quarry", value: "Mine / Quarry" },
    { label: "Nursing Home", value: "Nursing Home" },
    { label: "Pier / Wharf", value: "Pier / Wharf" },
    { label: "Prison", value: "Prison" },
    { label: "Resort", value: "Resort" },
    { label: "School", value: "School" },
    { label: "Self Storage", value: "Self Storage" },
    { label: "Terminal", value: "Terminal" },
    { label: "University", value: "University" },
    { label: "Utility Site", value: "Utility Site" },
    { label: "Water Treatment Plant", value: "Water Treatment Plant" },
];

export const areaTypeOptions = [
    { label: "Urban", value: "Urban" },
    { label: "Suburban", value: "Suburban" },
    { label: "Rural", value: "Rural" },
    { label: "Industrial", value: "Industrial" },
    { label: "Residential Zone", value: "Residential Zone" },
    { label: "Commercial Zone", value: "Commercial Zone" },
];

export const facilityTypeOptions = [
    { label: "Warehouse", value: "Warehouse" },
    { label: "Retail Center", value: "Retail Center" },
    { label: "Distribution Hub", value: "Distribution Hub" },
    { label: "Event Venue", value: "Event Venue" },
    { label: "Terminal", value: "Terminal" },
    { label: "Medical Facility", value: "Medical Facility" },
    { label: "Educational Facility", value: "Educational Facility" },
    { label: "Government Facility", value: "Government Facility" },
    { label: "Utility Site", value: "Utility Site" },
];

export const noteTypeOptions = [
    { label: "Action taken on a OSD item", value: "A" },
    { label: "Billing Notes", value: "B" },
    { label: "Customer Service Notes", value: "C" },
    { label: "Freight Bill Notes", value: "F" },
    { label: "General Probill Notes", value: "G" },
    { label: "Print Note on Invoice", value: "I" },
    { label: "Credit / Rebill", value: "N" },
    { label: "A/P Notes", value: "P" },
    { label: "OSD Resolved", value: "R" },
    { label: "Start OSD Exception", value: "S" },
    { label: "Driver Notes", value: "D" },
];

export interface VerifiedDetailsResponse {
    fullyVerified: boolean;
    fields: {
        [key: string]: {
            fieldKey: string;
            status: string;
            source: string;
            verifiedByName: string;
            verifiedAt: string;
            fieldValue: string;
        }
    }
}

export interface AddressCounts {
    liftGateRequiredTrue: number;
    limitedAccessTrue: number;
    total: number;
    residential: number;
    fullyVerified: number;
    gateCodeRequiredTrue: number;
}

export interface AppointmentResponse {
    confirmedDateTime: string;
    confirmedUser: string;
    date: string;
    earlyTime: string;
    lateTime: string;
    notes: string;
    contact: {
        id: string;
        dateCreated: string;
        dateUpdated: string;
        userCreated: string;
        userUpdated: string;
        firstName: string;
        lastName: string;
        title: string;
        phone: string;
        email: string;
        type: string;
    }
}

export const tableSize = 50;